import LogRocket from "logrocket";

import { appVersion } from "./appVersion";

export const registerLogRocket = (): typeof LogRocket => {
  // ! LogRocket
  const LogRocketAppId = import.meta.env.VITE_LOGROCKET_APP_ID;
  if (LogRocketAppId) {
    LogRocket.init(import.meta.env.VITE_LOGROCKET_APP_ID, {
      release: appVersion,
      rootHostname: import.meta.env.DEV ? "localhost" : "blackfisk.com",
    });
  }
  return LogRocket;
};
